<template>
  <div class="tokyo_tm_contact">
    <div class="tokyo_tm_title modern-title">
      <div class="title_flex">
        <div class="left">
          <span class="contact-badge">Contact</span>
          <h3>Get in Touch</h3>
          <p class="subtitle">We'd love to hear from you</p>
        </div>
      </div>
    </div>

    <div class="map_wrap modern-map">
      <iframe
        id="gmap_canvas"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3798.202544359311!2d31.048134400000013!3d-17.829137600000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1931a4e460eaa7cd%3A0xe2f3c514bf50a2cf!2s42%20Nelson%20Mandela%20Avenue%2C%20Harare!5e0!3m2!1sen!2szw!4v1672417187209!5m2!1sen!2szw"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
      ></iframe>
    </div>

    <div class="fields">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form class="contact_form" @submit.prevent="handleSubmit(onSubmit)">
          <div class="first">
            <ul>
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <li>
                  <input
                    v-model="formData.name"
                    type="text"
                    placeholder="Name"
                    autocomplete="off"
                  />
                  <span class="inpur-error">{{ errors[0] }}</span>
                </li>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <li>
                  <input
                    type="text"
                    rules="required|email"
                    v-model="formData.email"
                    placeholder="email"
                  />
                  <span class="inpur-error">{{ errors[0] }}</span>
                </li>
              </ValidationProvider>
              <ValidationProvider
                name="message"
                rules="required"
                v-slot="{ errors }"
              >
                <li>
                  <textarea
                    v-model="formData.message"
                    placeholder="Message"
                  ></textarea>
                  <span class="inpur-error">{{ errors[0] }}</span>
                </li>
              </ValidationProvider>
            </ul>
          </div>
          <div class="tokyo_tm_button">
            <button type="submit" class="ib-button">Send Message</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END FIELDS -->
  </div>
</template>

<script>
  import { ValidationObserver } from "vee-validate";
  import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data() {
      return {
        formData: {
          name: "",
          email: "",
          message: "",
        },
      };
    },
    methods: {
      onSubmit() {
        console.log(this.formData);
      },
    },
  };
</script>


<style lang="scss" scoped>
.tokyo_tm_contact {
  .modern-title {
    margin-bottom: 40px;

    .contact-badge {
      display: inline-block;
      padding: 8px 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border-radius: 30px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
      margin-bottom: 16px;
    }

    h3 {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .subtitle {
      color: #666;
      font-size: 16px;
    }
  }

  .modern-map {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    margin-bottom: 40px;
    height: 400px;

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .fields {
    .contact_form {
      .first ul {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 24px;

          input,
          textarea {
            width: 100%;
            padding: 16px 20px;
            border: 2px solid rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            font-size: 15px;
            transition: all 0.3s ease;
            background: white;

            &:focus {
              outline: none;
              border-color: #667eea;
              box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
            }

            &::placeholder {
              color: #999;
            }
          }

          textarea {
            min-height: 150px;
            resize: vertical;
            font-family: inherit;
          }

          .inpur-error {
            display: block;
            color: #e74c3c;
            font-size: 13px;
            margin-top: 8px;
            padding-left: 4px;
          }
        }
      }

      .tokyo_tm_button {
        margin-top: 32px;

        .ib-button {
          padding: 16px 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
          }

          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

.dark {
  .tokyo_tm_contact {
    .modern-title {
      .subtitle {
        color: #aaa;
      }
    }

    .fields {
      .contact_form {
        .first ul li {
          input,
          textarea {
            background: rgba(255, 255, 255, 0.05);
            border-color: rgba(255, 255, 255, 0.1);
            color: white;

            &:focus {
              border-color: #8b9cff;
              box-shadow: 0 0 0 3px rgba(139, 156, 255, 0.1);
            }

            &::placeholder {
              color: #666;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .tokyo_tm_contact {
    .modern-title h3 {
      font-size: 28px;
    }

    .modern-map {
      height: 300px;
    }
  }
}
</style>
